var map = {
	"./Aa.svg": 2693,
	"./aluno.svg": 5571,
	"./arrow_outline.svg": 9434,
	"./balloon.svg": 6360,
	"./balloon_pink.svg": 9460,
	"./book.svg": 6004,
	"./calendar.svg": 874,
	"./card.svg": 4479,
	"./chart.svg": 7208,
	"./coffee-outline.svg": 7063,
	"./company.svg": 5010,
	"./connect_logo_bar.svg": 9325,
	"./course.svg": 4004,
	"./document.svg": 8642,
	"./download.svg": 9007,
	"./download_pink.svg": 2273,
	"./email.svg": 7882,
	"./exit.svg": 3578,
	"./home.svg": 2520,
	"./joystick.svg": 7374,
	"./left_arrow.svg": 394,
	"./likes.svg": 5383,
	"./map.svg": 5477,
	"./notification.svg": 6037,
	"./pink_undo.svg": 24,
	"./player.svg": 8539,
	"./plus.svg": 3189,
	"./professor.svg": 5081,
	"./quotes.svg": 4215,
	"./refresh.svg": 4272,
	"./right_arrow.svg": 1396,
	"./tempAvatar.svg": 519,
	"./undo.svg": 5809,
	"./user.svg": 1816,
	"./wallet.svg": 3740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;